import axios from "../api";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { formatFechaSegura } from "../services/formatFechaSegura";
import { formatMoneda } from "../utils/formatMoneda";

const EditarTransaccional = () => {
  const { id } = useParams();
  const history = useHistory();
  const [transaccion, setTransaccion] = useState(null);
  const [original, setOriginalTransaccion] = useState(null);

  useEffect(() => {
    const fetchTransaccion = async () => {
      try {
        const res = await axios.get(`/transaccional/${id}`);
        setTransaccion(res.data);
        setOriginalTransaccion(res.data);
      } catch (error) {
        console.error("Error al obtener la transacción:", error);
        alert("Error al cargar los datos.");
      }
    };
    fetchTransaccion();
  }, [id]);

  const getCambios = () => {
    const cambios = {};
    Object.keys(transaccion).forEach(key => {
      if (transaccion[key] !== original[key]) {
        cambios[key] = {
          anterior: original[key],
          nuevo: transaccion[key],
        };
      }
    });
    return cambios;
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const cambiosDetectados = getCambios();

    if (Object.keys(cambiosDetectados).length === 0) {
      alert("No se han detectado cambios.");
      return;
    }

    let mensaje = "Cambios detectados:\n";
    for (const [campo, valores] of Object.entries(cambiosDetectados)) {
      mensaje += `${campo.toUpperCase()}: ${valores.anterior} → ${valores.nuevo}\n`;
    }

    if (window.confirm(mensaje + "\n¿Deseas continuar?")) {
      try {
        await axios.patch(`/cierres-dias/${id}`, transaccion);
        alert("Transacción actualizada.");
        history.push("/Planillas/transaccional", { transaccion });
      } catch (error) {
        console.error("Error al actualizar:", error);
        alert("Error al guardar los cambios.");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTransaccion(prev => ({ ...prev, [name]: value }));
  };

  


  if (!transaccion) return <div>Cargando...</div>;

  return (
    <div className="editar-cierre-container">
      <h2>Editar Transacción ID {id}</h2>
      <form onSubmit={handleSubmit} className="editar-form">
        <div className="form-row">
          <div className="form-group">
            <label>Fecha Inicial:</label>
            <input
              type="text"
              value={formatFechaSegura(transaccion.fecha_inicial)}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Placa:</label>
            <input
              type="text"
              value={transaccion.placa}
              disabled
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Valor Efectivo:</label>
            <input
              type="number"
              name="valor_ef"
              value={transaccion.valor_ef || ""}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Valor Datafono:</label>
            <input
              type="number"
              name="valor_datafono"
              value={transaccion.valor_datafono || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Total:</label>
            <input
              type="number"
              name="total"
              value={transaccion.total || ""}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Estado:</label>
            <select
              name="estado"
              value={transaccion.estado || ""}
              onChange={handleChange}
            >
              <option value="0">Pendiente</option>
              <option value="1">Confirmada</option>
              <option value="3">Anulada</option>
            </select>
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="guardar-btn">Guardar Cambios</button>
          <button
            type="button"
            className="cancelar-btn"
            onClick={() => history.push("/Planillas/transaccional")}
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditarTransaccional;
